<div id="cell" [class]="class">
    <div id="cell-value" *ngIf="cell.value">{{cell.value}}</div>
  </div>